// CARD IMPORTS
import pokemon1 from '../assets/images/cards/pokemon1.jpg';
import footballBox from '../assets/images/cards/footballBox.jpg';
import OPBox1 from '../assets/images/cards/OPBox1.jpg';
import MTGAC from '../assets/images/cards/MTGACBox.jpg';
// import topsBox2 from '../assets/images/cards/topsBox2.jpg';
// import topsBox3 from '../assets/images/cards/topsBox3.jpg';
import footballCards from '../assets/images/cards/footballCards.jpg';
// import UFC from '../assets/images/cards/UFC.jpg';
import basketball24PM from '../assets/images/cards/basketball24PM.jpg';
import football24PM from '../assets/images/cards/football24PM.jpg';
import pokemonSC from '../assets/images/cards/pokemonSC.jpg';
// import wwePrizm from '../assets/images/cards/wwePrizm.jpg';
// FUNKO IMPORTS
import animeFunko1 from '../assets/images/funko/animeFunko.jpg';
import batmanFunko1 from '../assets/images/funko/batmanFunko.jpg';
import funkoWall1 from '../assets/images/funko/funkoWall1.jpg';
import funkoWall2 from '../assets/images/funko/funkoWall2.jpg';
// HOTWHEEL IMPORTS
import hotwheelWall1 from '../assets/images/hotwheels/hotwheelWall1.jpg';
import hotwheelWall2 from '../assets/images/hotwheels/hotwheelWall2.jpg';
// STARTING LINEUP IMPORTS
import startingLineup1 from '../assets/images/startingLineup/startingLineup1.jpg';
import startingLineup2 from '../assets/images/startingLineup/startingLineup2.jpg';

// Product data for home page
const cards = [
    {
        "id": 1,
        "title": "Pokemon: 151 Japanese Booster Box (sv2a)",
        "image": pokemon1,
    },
    {
        "id": 2,
        "title": "Pokemon: Supercharged Breaker Japanese Booster Box (sv8)",
        "image": pokemonSC,
    },
    {
        "id": 3,
        "title": "One Piece TCG: Two Legends Booster Box [OP-08]",
        "image": OPBox1,
    },
    {
        "id": 4,
        "title": "Magic the Gathering: Universes Beyond Assassin's Creed Beyond Booster Box",
        "image": MTGAC,
    },
    {
        "id": 5,
        "title": "2023-24 Panini Mosaic Basketball Blaster Box",
        "image": basketball24PM,
    },
    {
        "id": 6,
        "title": "2024 Panini Prestige Football Blaster Box",
        "image": footballBox,
    },
    {
        "id": 7,
        "title": "2023 Panini Contedners Football Blaster Box",
        "image": footballCards,
    },
    {
        "id": 8,
        "title": "2024 Panini Mosaic Football Hobby Blaster Box (Red Mosaic)",
        "image": football24PM,
    },
    // {
    //     "id": 9,
    //     "title": "2024 Topps Chrome Baseball Blaster Box",
    //     "image": topsBox2,
    // },
    // {
    //     "id": 10,
    //     "title": "2024 Topps Holiday Baseball Mega Box",
    //     "image": topsBox3,
    // },

    // {
    //     "id": 11,
    //     "title": "2024 Topps Chrome UFC Blaster Box",
    //     "image": UFC,
    // },
    // {
    //     "id": 12,
    //     "title": "2024 Panini Prizm WWE Blaster Box",
    //     "image": wwePrizm,
    // }
]
const funkos = [
    {
        "id": 1,
        "title": "Anime Funkos",
        "image": animeFunko1,
    },
    {
        "id": 2,
        "title": "Batman Funkos",
        "image": batmanFunko1,
    },
    {
        "id": 3,
        // "title": "Funko Pop! Wall 1",
        "image": funkoWall1,
    },
    {
        "id": 4,
        // "title": "Funko Pop! Wall 2",
        "image": funkoWall2,
    }
]
const collectibles = [
    {
        "id": 1,
        // "title": "Hot Wheels Wall 1",
        "image": hotwheelWall1,
    },
    {
        "id": 2,
        // "title": "Hot Wheels Wall 2",
        "image": hotwheelWall2,
    },
    {
        "id": 3,
        // "title": "Starting Lineup Wall 1",
        "image": startingLineup1,
    },
    {
        "id": 4,
        // "title": "Starting Lineup Wall 2",
        "image": startingLineup2,
    }
]

export { cards, funkos, collectibles };